import { FunctionComponent } from "react";
import AboutImg from '../../../../assets/about-image.png'


const AboutContent: FunctionComponent = () => {
    return (
        <div className="px-8 py-6">
            <div className="flex flex-col lg:flex-row justify-between">
                <div className="lg:w-[45%]">
                    <img
                        src={AboutImg}
                        height={500}
                        width={610}
                        alt="About ClientVitals"
                    />
                </div>


                <div className="lg:w-[45%]">
                    <h3 className="font-sans tracking-wider text-6xl text-center lg:text-left lg:text-4xl font-semibold lg:border-b-2 lg:border-secondary w-full lg:w-fit lg:pr-2 lg:pb-2 lg:pl-12 my-8 lg:mt-0">
                        About
                    </h3>


                    <p className="lg:pl-12 mb-4">
                        We exist to empower credit-worthiness. That is our purpose, our passion, and our promise.
                    </p>


                    <p className="lg:pl-12 mb-4">
                        For more than a decade, we've provided credit counseling services that have done exactly that. And empowering those thousands of people has stoked our desire to empower a million more.
                    </p>


                    <p className="lg:pl-12 mb-4">
                        How to reach those millions of people for whom credit health awaits? We set out to unite our expertise in personal credit and technology to create a singularly powerful, way to understand and address personal credit: Make it understandable. Make it actionable. Make change. And make the final connection between lenders and borrowers
                    </p>
                   
                    <p className="lg:pl-12 mb-4">                      
                        It isn't easy but we're proud to be the team creating the revolutionary way to make it simple.
                    </p>
                </div>
            </div>
        </div>
    );
};


export default AboutContent;


